import { HomeIcon, CurrencyDollarIcon, MapPinIcon } from '@heroicons/react/24/outline';
import { Property } from '../../types/property';

interface PropertyCardProps {
  property: Property;
}

export default function PropertyCard({ property }: PropertyCardProps) {
  return (
    <div className="group h-full">
      <div className="relative h-full bg-white rounded-lg shadow-lg overflow-hidden transition-all duration-300 group-hover:-translate-y-1 group-hover:shadow-xl">
        <div className="relative h-48 overflow-hidden">
          <img 
            src={property.imageUrl} 
            alt={`${property.title} - ${property.type} property in ${property.location}`}
            className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
            loading="lazy"
            width="480"
            height="360"
          />
        </div>
        <div className="p-6">
          <div className="flex justify-between items-start mb-4">
            <div>
              <h3 className="text-xl font-semibold text-primary">{property.title}</h3>
              <div className="flex items-center text-gray-600">
                <MapPinIcon className="w-4 h-4 mr-1" />
                <span>{property.location}</span>
              </div>
            </div>
          </div>
          
          <div className="space-y-3 mb-6">
            <div className="flex items-center justify-between text-gray-600">
              <div className="flex items-center">
                <HomeIcon className="w-4 h-4 mr-1" />
                <span>{property.size.toLocaleString()} sq ft</span>
              </div>
              <div className="flex items-center">
                <CurrencyDollarIcon className="w-4 h-4 mr-1" />
                <span>{property.monthlyYield}% annual yield</span>
              </div>
            </div>
          </div>

          <div className="flex justify-between items-center gap-4">
            <a
              href="https://raydium.io/swap/?inputMint=sol&outputMint=EPW6L3UrX8ArF4SVsGFNNNs2XccugnJGNNzXLeHUCNuz"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-cta text-sm flex-1 text-center"
              aria-label={`Buy RENT tokens on Raydium to invest in ${property.title} property`}
              data-tracking="cta-click"
              data-tracking-location="property-card"
              data-tracking-destination="raydium"
            >
              Buy RENT
            </a>
            <a 
              href={
                property.title === "Bali"
                  ? "https://rebrand.ly/7gyusa3"
                  : property.title === "Vancouver" 
                    ? "https://rebrand.ly/ej66iok" 
                    : property.title === "Medellín" && property.monthlyYield === 12.34 
                      ? "https://rebrand.ly/1oad405"
                      : property.title === "Medellín" && property.monthlyYield === 10.41
                        ? "https://rebrand.ly/u9qdtkd"
                        : "#"
              }
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary text-sm flex-1 text-center"
              aria-label={`View detailed information about ${property.title} property`}
            >
              View Details
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}